<template lang="pug">
  .page-404(v-if="page404")
    .page-404__border.page-404__border--top
    .page-404__border.page-404__border--right
    .page-404__border.page-404__border--bottom
    .page-404__border.page-404__border--left
    .page-404__corner.page-404__corner--tl
    .page-404__corner.page-404__corner--tr
    .page-404__corner.page-404__corner--bl
    .page-404__corner.page-404__corner--br
    .page-404__content
      .page-404__title 404
      .page-404__subtitle Извините!<br>Страница не найдена
      router-link.page-404__btn(to="/") Вернуться на главную
</template>

<script>
import EventBus from '@/eventBus';

//import '@/components/page404/page404.styl';
import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';

// @ is an alias to /src
//import Footer from '@/components/common/footer/Footer.vue';

export default {
  name: 'Page404',

  mixins: [AjaxHelpersVue],

  data() {
    return {
      page404: null
    }
  },

  components: {
    //Footer
  },

  created() {
    // Загрузка данных для страницы
    EventBus.$on('load404Page', () => {
      this.request();
    });
  },

  methods: {
    request() {
      // Нейминг должен быть такой, без цифр в начале
      this.req('NotFoundPage:getNotFoundPage', {url: '*'}, res => {
        if(this.checkProperty(res.content)) {
          this.page404 = res.content;
        }
      }, 'page-404');
    }
  }
}
</script>
